import { z } from 'zod';
import { AnyDomainConfig, Domain } from './base';

/** Adds a migration when parsing states. */
export function withMigration<C extends AnyDomainConfig>(
  domain: Domain<C>,
  migrationZod: z.ZodTypeAny,
  extendDomainZod?: (domain: z.ZodTypeAny) => z.ZodTypeAny,
): Domain<C> {
  const domainZod = extendDomainZod
    ? extendDomainZod(domain.stateSchema)
    : domain.stateSchema;
  const stateSchema = z.union([domainZod, migrationZod]);
  return new Proxy(domain, {
    get(target, prop) {
      if (prop === 'stateSchema') {
        return stateSchema;
      }
      return Reflect.get(target, prop);
    },
  });
}
